import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./IconButton.module.css";

/**
 *  A button that adds a new list or deletes from the favorites.
 */
export function IconButton({ onClick, label, className, icon, iconNode }) {
  return (
    <div className={classNames(styles.container, className)} onClick={onClick}>
      {iconNode ? (
        <span className={styles.iconSvg} aria-hidden="true">
          {iconNode}
        </span>
      ) : (
        <img
          className={classNames(styles.icon, className)}
          src={icon}
          alt={"Icon"}
        />
      )}
      <div className={styles.label}>{label}</div>
    </div>
  );
}

IconButton.propTypes = {
  /**
   *  Function to call when the button is clicked.
   */
  onClick: PropTypes.func,
  /**
   *  A string for the button text.
   */
  label: PropTypes.string,
  /**
   *  A string to handle styling (color, etc.)
   */
  className: PropTypes.string,
  /**
   *  scr for the icon to the left
   */
  icon: PropTypes.string,
  /**
   * React node for inline SVG icon.
   */
  iconNode: PropTypes.node,
};
